import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';
import type { WidgetsConfig } from '@/widgets/dashboards';

interface ContextState {
  widgetsConfig: WidgetsConfig;
}

const Context = createContext<ContextState | null>(null);

interface Props {
  children: ReactNode;
  widgetsConfig: WidgetsConfig;
}

export const WidgetsConfigProvider = ({ children, widgetsConfig }: Props) => {
  const contextValue = useMemo(() => {
    return {
      widgetsConfig,
    };
  }, [widgetsConfig]);

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export const useWidgetsConfig = () => {
  const context = useContext(Context);

  if (!context) {
    throw new Error(
      'useWidgetsConfig hook used outside <WidgetsConfigProvider />',
    );
  }

  return context;
};
